import { BLAuth } from '@brandlive/client-auth';

export default new BLAuth(import.meta.env.VITE_API_HOST as string, import.meta.env.VITE_LOGIN_HOST as string);
